import {HttpParameterCodec} from '@angular/common/http'

export enum TokenServiceKey {
	email = 'email',
	accessToken = 'accessToken',
	refreshToken = 'refreshToken',
	tokenType = 'tokenType',
	tokenExpiry = 'tokenExpiry',
	clientId = 'clientId'
}

export interface IAuthToken {
	aud: string;
	roles: string[];
	email: string;
	exp: number;
	iat: number;
	iss: string;
	kid: string;
	clusterId: string;
	xuid: string;
	token_use: string;
}

// Cognito groups used for app user permissions, needs to match defined cognito groups
// TODO update once we know the cognito group
export enum PermissionCognitoGroups {
	registrations = 'SBC_RIDER_CARE_USER',
	appAdmin = 'APP_ADMIN',
	userAdmin = 'USER_ADMIN',
	systemAdmin = 'SYSTEM_ADMIN'
}

export class CustomURLEncoder implements HttpParameterCodec {
    encodeKey(key: string): string {
        return encodeURIComponent(key);
    }
    encodeValue(key: string): string {
        return encodeURIComponent(key);
    }
    decodeKey(key: string): string {
        return decodeURIComponent(key);
     }
    decodeValue(key: string) {
        return decodeURIComponent(key);
     }
}

